import React from "react";
import Logo from "../../img/loginLogo.png";
import { Formik, Form } from "formik";
import {
  validationSchema,
  initialValue,
} from "../../validation/RegisterValidation";
import {
  Button,
  CircularProgress,
  Fade,
  Grid,
  Typography,
} from "@material-ui/core";
import TextField from "../../components/TextField";

import { useHistory } from "react-router-dom";
import Store from "../../redux/Store";
import {
  getUserContact,
  setCaptchaCode,
} from "../../redux/Login/LoginActionCreators";
import Captcha from "../../components/Captcha";
import { SubmitRegister } from "../../redux/Login/LoginActions";
import { connect } from "react-redux";
const RegisterSendContact = ({ captchaCode, authError, loading }) => {
  const history = useHistory();
  React.useEffect(() => {
    Store.dispatch(setCaptchaCode(""));
  }, []);
  let [open, setOpen] = React.useState(false);

  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, submitProps) => {
        Store.dispatch(getUserContact(values.username));
        SubmitRegister(values).then((res) => {
          if (!res) {
            Store.dispatch(setCaptchaCode(""));
          }
        });
      }}
      validateOnMount
    >
      {(formik) => {
        return (
          <Form>
            <Fade in={open} timeout={500}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
              >
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  direction="column"
                  spacing={4}
                  xs={10}
                  sm={6}
                  md={5}
                  lg={4}
                  xl={3}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                    paddingTop: "51px",
                    paddingBottom: "51px",
                  }}
                >
                  <Grid
                    item
                    container
                    md={10}
                    xs={12}
                    justifyContent="center"
                    spacing={4}
                    style={{ margin: "auto" }}
                  >
                    <Grid item xs={12} container justifyContent="center">
                      <img src={Logo} alt="logo" />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center">
                      <Typography color="textSecondary" variant="subtitle2">
                        برای ثبت نام شماره موبایل یا ایمیل خود را وارد کنید
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography variant="body1" color="secondary">
                        {authError}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField name="username" label="شماره موبایل/ایمیل" />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center">
                      <Captcha />
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Button
                        style={{ fontWeight: "1000" }}
                        onClick={() => {
                          history.push("/");
                        }}
                        color="primary"
                      >
                        ورود با حساب کاربری
                      </Button>
                    </Grid>
                    <Grid item xs={12} container>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={
                          !formik.isValid || loading || captchaCode === ""
                        }
                      >
                        {!loading ? (
                          "  تایید"
                        ) : (
                          <CircularProgress
                            style={{
                              color: "white",
                              height: 24,
                              width: 24,
                            }}
                          />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { captchaCode, authError, loading } = loginReducer;

  return { captchaCode, authError, loading };
};

export default connect(mapStateToProps)(RegisterSendContact);
